import { render } from "./ListSlider.vue?vue&type=template&id=5a4cdc06"
import script from "./ListSlider.vue?vue&type=script&lang=js"
export * from "./ListSlider.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__